import produce from 'immer';
import { Reducer } from 'react';
import { Action } from './actions';
import { State } from './state';

const reducer: Reducer<State, Action> = produce((draft, action) => {
  switch (action.type) {
    case 'SET_PAGE':
      draft.auditLogPage = action.payload;
      break;
    default:
      throw new Error();
  }
});

export default reducer;
